const MAX_FILE_AMOUNT = 10;
const MAX_FILE_SIZE_MB = 20;
const WILDCARD_MAX_FILE_SIZE_MB = 100;
const SUPPORTED_TYPES = [
  "pdf",
  "jpeg",
  "jpg",
  "jpe",
  "jfif",
  "docx",
  "png",
  "xlsx",
  "doc",
  "txt",
  "asc",
  "tmp",
  "xls",
  "xlc",
  "xll",
  "xlm",
  "xlw",
  "xla",
  "xlt",
  "xld",
  "pptx",
  "csv",
  "xlsm",
  "odt",
  "tif",
  "tiff",
  "rtf",
  "bmp",
  "dib",
  "gif",
  "rar",
  "stl",
  "ai",
  "ppz",
  "ppt",
  "pps",
  "pot",
  "eml",
  "pub",
  "dotx",
  "webp",
  "eps",
  "epsi",
  "epsf",
  "dwg",
  "xbl",
  "xsd",
  "rng",
  "psd",
  "pgn",
  "ods",
  "ppsx",
  "oxps",
  "xps",
  "docm",
  "dxf",
  "gv",
  "dot",
  "wcm",
  "wdb",
  "wks",
  "wps",
  "xlr",
  "vcs",
  "ics",
  "log",
  "7z",
  "cdr",
  "vcard",
  "vcf",
  "vct",
  "gcrd",
  "epub",
  "xlsb",
  "pptm",
  "xspf",
  "wp",
  "wp4",
  "wp5",
  "wp6",
  "wpd",
  "wpp",
  "odp",
  "odg",
  "heic",
  "pages",
  "msg",
  "numbers",
  "gdoc",
  "atx20export",
  "qbb",
  "qbm",
  "qbo",
  "step",
  "stp",
  "st",
  "sldprt",
  "gsheet",
  "rpt",
  "indd",
];

const ORIGIN_TRACK_MAP = {
  'Dashboard quick actions': 'dashboard',
  'conversation_composer': 'conversation',
  'main_menu': 'quick_action',
  'Docuforms tab fab': 'doc_tab_fab',
  'matter_new_button': 'client_card',
  'client_list': 'client_list',
  'document_page': 'document_page',
};

export {
  MAX_FILE_AMOUNT,
  MAX_FILE_SIZE_MB,
  WILDCARD_MAX_FILE_SIZE_MB,
  SUPPORTED_TYPES,
  ORIGIN_TRACK_MAP
}
